import { defineMessages } from 'react-intl';

export default defineMessages({
    HomeDetails: {
        id: 'policy.common.component.policy-dwelling-info.Home Details',
        defaultMessage: 'Home Details',
    },
    DistanceToFireHydrant: {
        id: 'policy.common.component.policy-dwelling-info.Distance To Fire Hydrant',
        defaultMessage: 'Distance to Fire Hydrant',
    },
    DistanceToFireStation: {
        id: 'policy.common.component.policy-dwelling-info.Distance To Fire Station',
        defaultMessage: 'Distance to Fire Station',
    },
    FeetToFireHydrant: {
        id: 'policy.common.component.policy-dwelling-info.Feet To Fire Hydrant',
        defaultMessage: '{distance} ft',
    },
    MilesToFireStation: {
        id: 'policy.common.component.policy-dwelling-info.Miles',
        defaultMessage: '{miles} miles',
    },
    FloodingorFireHazard: {
        id: 'policy.common.component.policy-dwelling-info.Flooding or Fire Hazard',
        defaultMessage: 'Flooding or Fire Hazard',
    },
    WithinftofCommercialProperty: {
        id: 'policy.common.component.policy-dwelling-info.Within 300ft of Commercial Property',
        defaultMessage: 'Within 300ft of Commercial Property',
    },
    LocationType: {
        id: 'policy.common.component.policy-dwelling-info.Location Type',
        defaultMessage: 'Location Type',
    },
    ResidenceType: {
        id: 'policy.common.component.policy-dwelling-info.Residence Type',
        defaultMessage: 'Residence Type',
    },
    Homeisusedas: {
        id: 'policy.common.component.policy-dwelling-info.Home Type',
        defaultMessage: 'Home Type',
    },
    DwellingOccupied: {
        id: 'policy.common.component.policy-dwelling-info.Dwelling Occupied',
        defaultMessage: 'Dwelling Occupied',
    },
    Mortgagee: {
        id: 'policy.common.component.policy-dwelling-info.Mortgagee',
        defaultMessage: 'Mortgagee',
    },
    MortgageeName: {
        id: 'policy.common.component.policy-dwelling-info.Mortgagee Name',
        defaultMessage: 'Name',
    },
    MortgageeStreet: {
        id: 'policy.common.component.policy-dwelling-info.Mortgagee Street',
        defaultMessage: 'Street',
    },
    MortgageeCity: {
        id: 'policy.common.component.policy-dwelling-info.Mortgagee City',
        defaultMessage: 'City',
    },
    MortgageeState: {
        id: 'policy.common.component.policy-dwelling-info.Mortgagee State',
        defaultMessage: 'State',
    },
    ConstructionDetails: {
        id: 'policy.common.component.policy-dwelling-info.Construction Details',
        defaultMessage: 'Construction Details',
    },
    YearBuilt: {
        id: 'policy.common.component.policy-dwelling-info.Year Built',
        defaultMessage: 'Year Built',
    },
    ofStories: {
        id: 'policy.common.component.policy-dwelling-info.No of Stories',
        defaultMessage: 'No. of Stories',
    },
    Garage: {
        id: 'policy.common.component.policy-dwelling-info.Garage',
        defaultMessage: 'Garage',
    },
    ConstructionType: {
        id: 'policy.common.component.policy-dwelling-info.Construction Type',
        defaultMessage: 'Construction Type',
    },
    FoundationType: {
        id: 'policy.common.component.policy-dwelling-info.Foundation Type',
        defaultMessage: 'Foundation Type',
    },
    RoofType: {
        id: 'policy.common.component.policy-dwelling-info.Roof Type',
        defaultMessage: 'Roof Type',
    },
    RoofUpgraded: {
        id: 'policy.common.component.policy-dwelling-info.Roof Upgraded',
        defaultMessage: 'Roof Upgraded',
    },
    PlumbingType: {
        id: 'policy.common.component.policy-dwelling-info.Plumbing Type',
        defaultMessage: 'Plumbing Type',
    },
    PlumbingUpgraded: {
        id: 'policy.common.component.policy-dwelling-info.Plumbing Upgraded',
        defaultMessage: 'Plumbing Upgraded',
    },
    PrimaryHeatingType: {
        id: 'policy.common.component.policy-dwelling-info.Primary Heating Type',
        defaultMessage: 'Primary Heating Type',
    },
    HeatingUpgraded: {
        id: 'policy.common.component.policy-dwelling-info.Heating Upgraded',
        defaultMessage: 'Heating Upgraded',
    },
    WiringType: {
        id: 'policy.common.component.policy-dwelling-info.Wiring Type',
        defaultMessage: 'Wiring Type',
    },
    ElectricalSystem: {
        id: 'policy.common.component.policy-dwelling-info.Electrical System',
        defaultMessage: 'Electrical System',
    },
    TotalTaxes: {
        id: 'policy.common.component.policy-dwelling-info.Total Taxes',
        defaultMessage: 'Total Taxes',
    },
    TotalCost: {
        id: 'policy.common.component.policy-dwelling-info.Total Cost',
        defaultMessage: 'Total Cost',
    },
    WiringUpgraded: {
        id: 'policy.common.component.policy-dwelling-info.Wiring Upgraded',
        defaultMessage: 'Wiring Upgraded',
    },
    ProtectionDetails: {
        id: 'policy.common.component.policy-dwelling-info.Protection Details',
        defaultMessage: 'Protection Details',
    },
    FireExtinguisher: {
        id: 'policy.common.component.policy-dwelling-info.Fire Extinguisher',
        defaultMessage: 'Fire Extinguisher',
    },
    BurglarAlarm: {
        id: 'policy.common.component.policy-dwelling-info.Burglar Alarm',
        defaultMessage: 'Burglar Alarm',
    },
    MonitoringCenterFireAlarm: {
        id: 'policy.common.component.policy-dwelling-info.Monitoring Center Fire Alarm',
        defaultMessage: 'Monitoring Center Fire Alarm',
    },
    SmokeAlarms: {
        id: 'policy.common.component.policy-dwelling-info.Smoke Alarms',
        defaultMessage: 'Smoke Alarms',
    },
    PolicyType: {
        id: 'policy.common.component.policy-dwelling-info.Policy Type',
        defaultMessage: 'Policy Type',
    },
    DeadBolts: {
        id: 'policy.common.component.policy-dwelling-info.Dead Bolts',
        defaultMessage: 'Deadbolts',
    },
    ResidenceVisibletoNeighbours: {
        id: 'policy.common.component.policy-dwelling-info.Residence Visible to Neighbours',
        defaultMessage: 'Residence Visible to Neighbours',
    },
    SprinklerSystemType: {
        id: 'policy.common.component.policy-dwelling-info.Sprinkler System Type',
        defaultMessage: 'Sprinkler System Type',
    },
    RoomersorBorders: {
        id: 'policy.common.component.policy-dwelling-info.Roomers or Borders',
        defaultMessage: 'Roomers or Borders',
    },
    ofUnits: {
        id: 'policy.common.component.policy-dwelling-info.No. of Units',
        defaultMessage: 'No. of Units',
    },
    FireplaceorWoodstove: {
        id: 'policy.common.component.policy-dwelling-info.Fireplace or Woodstove',
        defaultMessage: 'Fireplace or Woodstove',
    },
    SwimmingPool: {
        id: 'policy.common.component.policy-dwelling-info.Swimming Pool',
        defaultMessage: 'Swimming Pool',
    },
    Trampoline: {
        id: 'policy.common.component.policy-dwelling-info.Trampoline',
        defaultMessage: 'Trampoline',
    },
    FloodingWaterLeakinpastYears: {
        id: 'policy.common.component.policy-dwelling-info.Flooding/Water Leak in past 5 Years',
        defaultMessage: 'Flooding/Water Leak in past 5 Years',
    },
    SectionICoverages: {
        id: 'policy.common.component.policy-dwelling-info.Section I Coverages',
        defaultMessage: 'Section I Coverages',
    },
    SectionIICoverages: {
        id: 'policy.common.component.policy-dwelling-info.Section II Coverages',
        defaultMessage: 'Section II Coverages',
    },
    AdditionalLiabilityCoverages: {
        id: 'policy.common.component.policy-dwelling-info.Additional Liability Coverages',
        defaultMessage: 'Additional Liability Coverages',
    },
    AdditionalPropertyCoverages: {
        id: 'policy.common.component.policy-dwelling-info.Additional Property Coverages',
        defaultMessage: 'Additional Property Coverages',
    },
    infoYes: {
        id: 'policy.common.component.policy-dwelling-info.Yes',
        defaultMessage: 'Yes',
    },
    infoNo: {
        id: 'policy.common.component.policy-dwelling-info.No',
        defaultMessage: 'No',
    },
    coverages: {
        id: 'policy.common.component.policy-dwelling-info.Coverages For',
        defaultMessage: 'Coverages',
    },
});
